module.exports = __webpack_public_path__ + "static/media/new-york-4.ed9573cf.jpg";